import { render, staticRenderFns } from "./GenericRadioGroup.vue?vue&type=template&id=86b0b242&scoped=true"
import script from "./GenericRadioGroup.vue?vue&type=script&lang=js"
export * from "./GenericRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b0b242",
  null
  
)

export default component.exports